import { createResource } from "solid-js";
import type { PricingPlans } from "../../shared/api";
import { api } from "../api";

// Pricing plans from the GBFS feed (GET /api/pricing), fetched once; empty on failure.
const [plans] = createResource<PricingPlans>(
  () => api.get<PricingPlans>("/pricing").catch(() => ({})),
  {
    initialValue: {},
  },
);

/** All plans (prices page). `pricingPlans.loading` is true until the first answer. */
export const pricingPlans = plans;

/** Display label of a vehicle's plan, e.g. "1,00 € + 0,29 € / min". */
export const priceLabelFor = (planId: string | undefined) =>
  planId ? plans()[planId]?.label : undefined;
